import {t} from "i18next";
import NavigationLink from "../NavigationLink/index"
import styles from "./index.module.scss"

const Sidebar = ({ routes, currentPath, onLinkClick }) => {
    return (
        <nav className={styles.sidebar}>
            <ul className={styles.nav_list}>
                {routes.map(route =>
                    route.sidebarProfile.map((sidebarItem, index) => (
                        <NavigationLink
                            key={index}
                            to={sidebarItem.to}
                            name={t(sidebarItem.title)}
                            isActive={currentPath === sidebarItem.to}
                            onLinkClick={onLinkClick}
                        />
                    ))
                )}
            </ul>
        </nav>
    )
}

export default Sidebar